import { isLocale, useTranslation } from '@platform/i18n';
import type { RouterHistory } from '@tanstack/react-router';
import { useEffect } from 'react';
import { useShell } from '../shell/shell.store.ts';
import { localeOfPath, showLocaleInUrl } from './locale-path.ts';

export const useLocaleFromUrl = (history: RouterHistory): void => {
  const { i18n } = useTranslation();
  const setLocale = useShell((state) => state.setLocale);

  useEffect(() => {
    const followUrl = (): void => {
      const locale = localeOfPath(history.location.pathname);
      if (locale === null) {
        if (isLocale(i18n.language)) showLocaleInUrl(history, i18n.language);
        return;
      }
      if (locale === i18n.language) return;
      void i18n.changeLanguage(locale);
      setLocale(locale);
    };
    followUrl();
    return history.subscribe(followUrl);
  }, [history, i18n, setLocale]);
};
